


import { initGlobals } from '..';
import withBrowserCheck from 'src/components/common/unsupported-browser';
import PublicProvider from 'src/components/public-provider';
import Lazy from 'src/components/common/lazy';
import Match from 'src/components/common/match';
import React, { Component } from 'react';
import publicStore from 'src/stores/public-store';
import routes from './routes';
import UiGlobals from 'src/components/common/ui-globals';
import { configureRouter } from 'src/router';
import { observer } from 'mobx-react';
import { hot } from 'react-hot-loader';

initGlobals();
window.publicStore = publicStore;
publicStore.initialize(window.Glide);

if (window.router) {
  // hmr
  window.router.stop();
}

window.router = configureRouter(publicStore, routes);

const router = window.router;
router.start();

const clsPrefix = 'public-app';

@withBrowserCheck()
@observer
class Root extends Component {
  // eslint-disable-line
  render() {
    return (
      <PublicProvider store={publicStore} router={router}>
        <div className={`${clsPrefix}__container`}>
          <UiGlobals
            ui={publicStore.ui}
            features={publicStore.features}
            signaturePackets={publicStore.signaturePackets}
          />
          <Match
            routeName="demo"
            activeStrict
            ignoreParams
            render={(route) => (
              <Lazy route={route} component={() => import('./demo')} />
            )}
          />
          <Match
            routeName="sharedItem"
            activeStrict
            ignoreParams
            render={(route) => (
              <Lazy route={route} component={() => import('./shared-item')} />
            )}
          />
          <Match
            routeName="sharedDocumentStatus"
            activeStrict
            ignoreParams
            render={(route) => (
              <Lazy
                route={route}
                component={() => import('./shared-document/status')}
              />
            )}
          />
          {/* <Match
            routeName="petition"
            activeStrict
            ignoreParams
            render={(route) => (
              <Lazy route={route} component={() => import('./petition')} />
            )}
          /> */}
          <Match
            routeName="sharedItem.unsubscribe"
            activeStrict
            ignoreParams
            render={(route) => (
              <Lazy route={route} component={() => import('./shared-item')} />
            )}
          />
          <Match
            routeName="requestAccess"
            activeStrict
            ignoreParams
            render={(route) => (
              <Lazy
                route={route}
                component={() => import('./request-access')}
              />
            )}
          />
          <Match
            routeName="flow.page"
            ignoreParams
            render={(route) => (
              <Lazy
                route={route}
                component={() => import('components/flows/flow')}
              />
            )}
          />
          <Match
            routeName="forms"
            ignoreParams
            render={(route) => (
              <Lazy route={route} component={() => import('./forms')} />
            )}
          />
          <Match
            routeName="pp"
            activeStrict
            ignoreParams
            render={(route) => (
              <Lazy route={route} component={() => import('./pp')} />
            )}
          />
          <Match
            routeName="pp.submitOfferError"
            activeStrict
            ignoreParams
            render={(route) => (
              <Lazy
                route={route}
                component={() => import('./pp/submit-offer-error')}
              />
            )}
          />
          <Match
            routeName="docusign-placeholder"
            activeStrict
            ignoreParams
            render={(route) => (
              <Lazy
                route={route}
                component={() => import('./integrations/docusign-placeholder')}
              />
            )}
          />
          <Match
            routeName="redirect"
            activeStrict
            render={(route) => (
              <Lazy route={route} component={() => import('./redirect')} />
            )}
          />
        </div>
      </PublicProvider>
    );
  }
}

export default hot(module)(Root);
